export default __webpack_public_path__ + "static/media/RFBin-video.1fe65b6c.mp4";